module.exports = __webpack_public_path__ + "static/hajkova-6e3781e009c18245f4e80fffbe951625.jpg";